e.N = e.NewsFeed = {
	init : function(){
		e.N.my_news_feed.init();
		e.N.homework_tracker.init();
	}
};